/**
 * recordUtils.js
 * 출석 및 심방 기록을 기반으로 학생/교사 데이터를 강화하는 유틸리티
 */

/**
 * 학생 또는 교사 데이터에 최근 출석 및 심방 날짜를 추가합니다.
 * @param {Object} item 학생 또는 교사 객체
 * @param {Array} attendanceLogs 출석 로그 배열
 * @param {Array} visitLogs 심방 로그 배열
 * @returns {Object} 강화된 데이터 객체
 */
export function enrichRecord(item, attendanceLogs = [], visitLogs = []) {
  if (!item) return item;

  // 1. 최근 출석 계산 (출석: present, 지각: late)
  const myAttendance = (attendanceLogs || []).filter(
    (log) => log && (log[item.id] === "present" || log[item.id] === "late")
  );
  
  let lastAttendance = null;
  if (myAttendance.length > 0) {
    // 날짜 기준 내림차순 정렬 후 첫 번째 요소의 날짜 선택
    const sorted = [...myAttendance].sort((a, b) => new Date(b.date) - new Date(a.date));
    lastAttendance = sorted[0].date;
  }

  // 2. 최근 심방 계산
  const myVisits = (visitLogs || []).filter(
    (log) => log && log.studentId === item.id && log.date
  );

  let lastVisit = null;
  if (myVisits.length > 0) {
    const sorted = [...myVisits].sort((a, b) => new Date(b.date) - new Date(a.date));
    lastVisit = sorted[0].date;
  }

  const resolvedLastAttendance =
    lastAttendance ?? (item.lastAttendance === "-" ? null : item.lastAttendance ?? null);
  const resolvedLastVisit =
    lastVisit ?? (item.lastVisit === "-" ? null : item.lastVisit ?? null);

  return {
    ...item,
    lastAttendance: resolvedLastAttendance,
    lastVisit: resolvedLastVisit,
  };
}

/**
 * 리스트 전체를 강화합니다.
 */
export function enrichRecords(items, attendanceLogs, visitLogs) {
  if (!Array.isArray(items)) return [];
  return items.map(item => enrichRecord(item, attendanceLogs, visitLogs));
}
